import { render, staticRenderFns } from "./MedicinalPlant.vue?vue&type=template&id=1663838f&"
import script from "./MedicinalPlant.vue?vue&type=script&lang=js&"
export * from "./MedicinalPlant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports